define('components/background-theme-selection-component/models/single-theme-selection-author',[], function() {
    "use strict";
    var SingleThemeSelectionAuthorModel = Backbone.Model.extend({

        "defaults": function() {
            return {
                "themeIndex": null,
                "themeIndexText": null,
                "themeGuid": null,
                "themeName": null,
                "themeDescription": null,
                "themeAvatarImageData": null,
                "isThemeDataValid": false,
                "isAccTextSame": false,
                "accTextAreaCheckboxId": null,
                "accText": null
            };
        }

    }, {
        "DEFAULT_EDITOR_SIZE": {
            "NAME_EDITOR_WIDTH": 250,
            "NAME_EDITOR_HEIGHT": 50,
            "DESCRIPTION_EDITOR_WIDTH": 450,
            "DESCRIPTION_EDITOR_HEIGHT": 100
        },

        "EVENTS": {
            "DELETE_THEME": "delete-theme"
        }
    });
    return SingleThemeSelectionAuthorModel;
});

